import { Component, Input } from '@angular/core';

@Component({
  selector: 'axis',
  templateUrl: 'axis.html'
})
export class AxisComponent {

  @Input()
  leftAxis: string;

  @Input()
  bottomAxis: string;

  constructor() {

  }

}



// WEBPACK FOOTER //
// ./src/components/axis/axis.ts